/**
 * Abre/descarga un archivo a partir de una URL (p. ej. la URL de PDF que
 * devuelve `exportBillingToPdf`). Para URLs cross-origin el atributo `download`
 * suele ignorarse, por lo que abrimos en una pestaña nueva como fallback —
 * el navegador muestra el PDF y el usuario puede guardarlo.
 */
export function downloadFromUrl(url: string, filename?: string): void {
  const a = document.createElement('a')
  a.href = url
  if (filename) a.download = filename
  a.target = '_blank'
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
}

/**
 * Descarga un archivo a partir de sus bytes en base64 (p. ej. el PDF que
 * `portalExportBillingToPdf` genera al vuelo, sin persistir en MinIO). Arma un
 * Blob y dispara la descarga; libera el object URL al terminar.
 */
export function downloadFromBase64(
  base64: string,
  filename: string,
  mime = 'application/pdf',
): void {
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  const objectUrl = URL.createObjectURL(new Blob([bytes], { type: mime }))
  try {
    const a = document.createElement('a')
    a.href = objectUrl
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
  } finally {
    URL.revokeObjectURL(objectUrl)
  }
}
